import { Button, Table } from 'reactstrap';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faTruck, faUser } from '@fortawesome/free-solid-svg-icons';
import { JobStatusTypes } from './Dispatch';

export const PlanningBoard = ({ planningBoard, handlePlanningStatusToggle, selectedPlanningFilter }) => (
    <div className="scoreboard">
        <Table
            size="sm"
            bordered
        >
            <thead>
                <tr>
                    <th className="text-center" />

                    <th
                        className={clsx('text-center assignment-status-label unfilled', {
                            selected: selectedPlanningFilter === JobStatusTypes.UNFILLED,
                        })}
                    >
                        <Button
                            size="sm"
                            color="link"
                            onClick={() => handlePlanningStatusToggle(JobStatusTypes.UNFILLED)}
                        >
                            <FontAwesomeIcon
                                icon={faMagnifyingGlass}
                                className="mr-1"
                            />
                            <span>{JobStatusTypes.UNFILLED}</span>
                        </Button>
                    </th>

                    <th
                        className={clsx('text-center assignment-status-label scheduled', {
                            selected: selectedPlanningFilter === JobStatusTypes.SCHEDULED,
                        })}
                    >
                        <Button
                            size="sm"
                            color="link"
                            onClick={() => handlePlanningStatusToggle(JobStatusTypes.SCHEDULED)}
                        >
                            <FontAwesomeIcon
                                icon={faMagnifyingGlass}
                                className="mr-1"
                            />
                            <span>{JobStatusTypes.SCHEDULED}</span>
                        </Button>
                    </th>

                    <th
                        className={clsx('text-center assignment-status-label noResponse', {
                            selected: selectedPlanningFilter === JobStatusTypes.NO_RESPONSE,
                        })}
                    >
                        <Button
                            size="sm"
                            color="link"
                            onClick={() => handlePlanningStatusToggle(JobStatusTypes.NO_RESPONSE)}
                        >
                            <FontAwesomeIcon
                                icon={faMagnifyingGlass}
                                className="mr-1"
                            />
                            <span>{JobStatusTypes.NO_RESPONSE}</span>
                        </Button>
                    </th>

                    <th
                        className={clsx('text-center assignment-status-label confirmed', {
                            selected: selectedPlanningFilter === JobStatusTypes.CONFIRMED,
                        })}
                    >
                        <Button
                            size="sm"
                            color="link"
                            onClick={() => handlePlanningStatusToggle(JobStatusTypes.CONFIRMED)}
                        >
                            <FontAwesomeIcon
                                icon={faMagnifyingGlass}
                                className="mr-1"
                            />
                            <span>{JobStatusTypes.CONFIRMED}</span>
                        </Button>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td className="text-center font-bold">
                        <FontAwesomeIcon icon={faUser} />
                    </td>
                    <td className="text-center">
                        {
                            planningBoard
                                .staff
                                .unfilled
                        }
                    </td>
                    <td className="text-center">
                        {
                            planningBoard
                                .staff
                                .scheduled
                        }
                    </td>
                    <td className="text-center">
                        {
                            planningBoard
                                .staff
                                .noResponse
                        }
                    </td>
                    <td className="text-center">
                        {
                            planningBoard
                                .staff
                                .confirmed
                        }
                    </td>
                </tr>
                <tr>
                    <td className="text-center font-bold">
                        <FontAwesomeIcon icon={faTruck} />
                    </td>
                    <td className="text-center">
                        {
                            planningBoard
                                .equipment
                                .unfilled
                        }
                    </td>
                    <td className="text-center">
                        {
                            planningBoard
                                .equipment
                                .scheduled
                        }
                    </td>
                    <td className="text-center">
                        {
                            planningBoard
                                .equipment
                                .noResponse
                        }
                    </td>
                    <td className="text-center">
                        {
                            planningBoard
                                .equipment
                                .confirmed
                        }
                    </td>
                </tr>
            </tbody>
        </Table>
    </div>
);